import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PermissionsModule } from '@sentry/permissions';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';
import { MaterialThemeModule } from './material-theme.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ReadonlyFieldComponent } from './readonly-field/readonly-field.component';
import { SkeletonLoaderComponent } from './skeleton-loader/skeleton-loader.component';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { DataGridComponent } from './data-grid/data-grid.component';
import { ToolBarComponent } from './tool-bar/tool-bar.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ReferencesDialogComponent } from './references-dialog/references-dialog.component';
import { EmptyPipe } from './pipes/empty.pipe';
import { ListPipe } from './pipes/list.pipe';
import { YesNoPipe } from './yes-no.pipe';
import { OrderByPipe } from './order-by.pipe';

@NgModule({
  imports: [
    MatListModule,
    NgxSkeletonLoaderModule,
    CommonModule,
    MatIconModule,
    MatMenuModule,
    MatDialogModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatButtonModule,
    AgGridModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    FormsModule,
    MaterialThemeModule,
    RouterModule,
    PermissionsModule,
    ReadonlyFieldComponent,
    SkeletonLoaderComponent,
    EmptyStateComponent,
    DataGridComponent,
    ToolBarComponent,
    ConfirmDialogComponent,
    ReferencesDialogComponent,
    EmptyPipe,
    ListPipe,
    YesNoPipe,
    OrderByPipe,
  ],
  declarations: [],
  exports: [
    MaterialThemeModule,
    ReadonlyFieldComponent,
    SkeletonLoaderComponent,
    EmptyStateComponent,
    DataGridComponent,
    ToolBarComponent,
    ConfirmDialogComponent,
    ReferencesDialogComponent,
    EmptyPipe,
    ListPipe,
    YesNoPipe,
    OrderByPipe,
  ],
})
export class ThemeModule {}
